import { Clapperboard, Sparkles } from 'lucide-react';
import { FLAGSHIP, SERVICES, displayTitle } from '../data/website';

export const HeroFeatures = () => <div className="hero-features" data-testid="hero-feature-bar">
  <a href="#experiences" className="hero-feature" data-testid="hero-feature-cinema">
    <Clapperboard className="feature-icon" size={37} strokeWidth={1.2} />
    <div className="feature-copy"><h2>7D Cinema</h2><p>{FLAGSHIP.note}<br />Experience the story. Don't just watch it.</p></div>
    <img src="/media/movie-theatres.webp" alt="Illustrative cinema experience" />
  </a>
  <span className="feature-divider" aria-hidden="true" />
  <a href="#what-we-do" className="hero-feature" data-testid="hero-feature-immersive">
    <Sparkles className="feature-icon" size={37} strokeWidth={1.2} />
    <div className="feature-copy"><h2>{displayTitle(SERVICES[0].title)}</h2><p>Entertainment. Technology.<br />Culture. Experiences.</p></div>
    <img src={SERVICES[0].image} alt="Illustrative immersive projection environment" />
  </a>
</div>;